// Malti. Please have a native speaker review before launch.
export default {
    // Research papers page (/research)
    "nav.globe": "Globu",
    "nav.research": "Riċerka",
    "rs.title": "Studji ta’ riċerka",
    "rs.sub": "Riċerka ġdida dwar il-finanzi kwantitattivi u l-banek ċentrali minn arXiv, il-Fed, il-BĊE, il-BIS u l-NBER. B’xejn għall-qari fis-sors; aġġornata kull 6 sigħat.",
    "rs.search": "Fittex titli, awturi, sommarji…",
    "rs.allTopics": "It-temi kollha",
    "rs.allSources": "Is-sorsi kollha",
    "rs.allCountries": "Il-pajjiżi kollha",
    "rs.count": "{n} studji",
    "rs.none": "L-ebda studju ma jaqbel ma’ dawn il-filtri.",
    "rs.clear": "Neħħi l-filtri",
    "rs.download": "Niżżel il-PDF minn {source}",
    "rs.read": "Aqra fuq {source}",
    "rs.onGlobe": "Iftaħ {country} fuq il-globu",
    "rs.note": "It-titli, l-awturi u s-sommarji jwasslu għall-pubblikaturi oriġinali; il-PDFs jinfetħu fuq is-siti tagħhom. Riċerka, mhux parir finanzjarju.",
    "rs.global": "Globali",
    "rs.loadMore": "Ara aktar",
    "rs.details": "Dettalji",
    "rs.copy": "Ikkopja l-link",
    "rs.copied": "Il-link ġie kkupjat",
    "rs.published": "Ippubblikat",
    "panel.research": "Riċerka dwar {country}",
    "panel.researchAll": "Ir-riċerka kollha →",
    "rt.trading": "Kummerċ u struttura tas-suq",
    "rt.portfolio": "Portafolli u investiment",
    "rt.risk": "Riskju",
    "rt.pricing": "Derivattivi u mudelli tal-prezzijiet",
    "rt.forecasting": "IA u tbassir",
    "rt.crypto": "Cripto u assi diġitali",
    "rt.macro": "Ekonomija u banek ċentrali",
    "topic.r-trading": "Ir-riċerka dwar il-kummerċ tistudja kif jiffurmaw il-prezzijiet u kif jiġu eżegwiti l-ordnijiet: strateġiji, kotba tal-ordnijiet, likwidità u spejjeż.",
    "topic.r-portfolio": "Ir-riċerka dwar il-portafolli tistaqsi kif tgħaqqad l-investimenti: liema fatturi jispjegaw ir-redditi, kif tibbilanċja r-riskju u r-redditu, u kif tinvesti għall-pensjoni.",
    "topic.r-risk": "Ir-riċerka dwar ir-riskju tkejjel x’jista’ jmur ħażin: telf kbir, waqgħat fis-suq, falliment tal-banek u kif tipproteġi ruħek.",
    "topic.r-pricing": "Ir-riċerka dwar il-prezzijiet tibni l-matematika li tivvaluta l-opzjonijiet u kuntratti oħra, u l-mudelli tal-volatilità.",
    "topic.r-forecasting": "Ir-riċerka dwar l-IA u t-tbassir tittestja jekk it-tagħlim awtomatiku, il-mudelli tal-lingwa u l-istatistika jistgħux ibassru l-prezzijiet jew l-ekonomija, u kemm b’mod affidabbli.",
    "topic.r-crypto": "Ir-riċerka dwar il-cripto tistudja l-kriptovaluti, l-istablecoins, il-blockchains u l-assi tokenizzati: kif jinnegozjaw u x’riskji għandhom.",
    "topic.r-macro": "Ir-riċerka ekonomika tħares lejn it-tkabbir, l-inflazzjoni, ir-rati tal-imgħax u l-politika tal-banek ċentrali, li jmexxu s-swieq għal xhur u snin.",
    'lang.label': 'Lingwa',
    'nav.reports': 'Rapporti',
    'nav.stocks': 'Segwi l-ishma',
    loading: 'Qed jitgħabbew l-aħbarijiet tad-dinja…',
    'err.title': 'Ma setax jitgħabba',
    'err.msg': 'Inqala’ xi żball waqt li kienet qed titgħabba l-applikazzjoni.',
    'err.retry': 'Erġa’ pprova',
    atlas: 'Atlas',
    'search.label': 'Fittex pajjiżi',
    'search.ph': 'Fittex pajjiżi jew kodiċijiet…',
    'filter.region': 'Reġjun',
    'filter.allRegions': 'Ir-reġjuni kollha',
    'filter.window': 'Perjodu',
    'filter.topic': 'Suġġett',
    'filter.all': 'Kollha',
    'stage.title': 'Is-swieq, issa',
    legend: 'Leġġenda',
    lastUpdate: 'L-aħħar aġġornament',
    pauseRotation: 'Waqqaf ir-rotazzjoni',
    resumeRotation: 'Kompli r-rotazzjoni',
    hint: 'Kaxkar biex iddawwar · ikklikkja punt biex tiftaħ pajjiż',
    'panel.latest': 'L-aħħar aħbarijiet',
    'quiet.none': 'M’hemmx aħbarijiet f’dan il-perjodu.',
    'quiet.sub': 'Ipprova perjodu itwal (7J jew 30J), jew segwi dan il-pajjiż biex iżżommu fil-lista tiegħek.',
    'footer.about': 'Dwarna',
    'footer.privacy': 'Privatezza',
    'footer.terms': 'Termini',
    follow: '☆ Segwi',
    following: '★ Qed issegwi',
    followingGroup: 'Qed issegwi',
    explain: 'Spjegali',
    hideExplain: 'Aħbi l-ispjegazzjoni',
    share: 'Aqsam',
    whyMatter: 'Għaliex jista’ jkun importanti',
    disclaimer: 'Kuntest edukattiv, mhux parir finanzjarju.',
    readAt: 'Aqra l-istorja sħiħa fuq {source}',
    translate: 'Ittraduċi',
    showing: 'Qed jintwerew {n} minn {total}',
    loadMore: 'Għabbi {n} oħra',
    loadingShort: 'Qed jitgħabba…',
    'story.one': '{n} aħbar',
    'story.other': '{n} aħbarijiet',
    noStories: 'l-ebda aħbar',
    justNow: 'Bħalissa',
    minAgo: '{n} min ilu',
    hAgo: '{n} siegħa ilu',
    dAgo: '{n} jum ilu',
    'range.24h': 'l-aħħar 24 siegħa',
    'range.7d': 'l-aħħar 7 ijiem',
    'range.30d': 'l-aħħar 30 jum',
    'range.all': 'il-perjodu kollu',
    'cont.Africa': 'Afrika',
    'cont.Asia': 'Asja',
    'cont.Europe': 'Ewropa',
    'cont.North America': 'Amerika ta’ Fuq',
    'cont.Oceania': 'Oċeanja',
    'cont.South America': 'Amerika t’Isfel',
    'cat.markets': 'Swieq',
    'cat.economy': 'Ekonomija',
    'cat.central-banks': 'Banek ċentrali',
    'cat.policy': 'Politika u ġeopolitika',
    'cat.companies': 'Kumpaniji',
    today: 'Illum',
    'today.top': 'Id-dinja f’60 sekonda',
    'today.banks': 'Deċiżjonijiet tal-banek ċentrali',
    'today.mine': 'Il-pajjiżi tiegħek',
    'today.emptyTop': 'Għad m’hemmx aħbarijiet ewlenin illum. Erġa’ ara aktar tard.',
    'today.emptyMine': 'Agħfas ☆ Segwi fuq kwalunkwe pajjiż biex tqiegħdu hawn.',
    'today.note': 'It-titli jwasslu għas-sorsi oriġinali. Kuntest edukattiv biss, mhux parir finanzjarju.',
    'today.open': 'Iftaħ {country}',
    close: 'Agħlaq',
    'cal.timeVaries': 'il-ħin ivarja',
    'cal.yourTime': '{time} skont il-ħin tiegħek',
    'cal.in': 'fi żmien {t}',
    'cal.today': 'Id-deċiżjoni titħabbar illum',
    'bank.fed': 'Federal Reserve',
    'bank.ecb': 'Bank Ċentrali Ewropew',
    'bank.boe': 'Bank tal-Ingilterra',
    'bank.boj': 'Bank tal-Ġappun',
    'auth.signIn': 'Idħol',
    'auth.account': 'Kont',
    'auth.btnTitle': 'Kont b’xejn: żomm il-pajjiżi tiegħek fuq kull apparat',
    'auth.freeTitle': 'Kont b’xejn',
    'auth.freeSub': "Żomm il-pajjiżi li ssegwi fuq l-apparati kollha tiegħek. L-ebda password: nibagħtulek kodiċi ta' darba bl-email.",
    'auth.emailBtn': "Ibgħatli kodiċi biex nidħol",
    'auth.sending': 'Qed jintbagħat…',
    'auth.check': 'Iċċekkja l-email tiegħek: il-link jiskadi wara 20 minuta.',
    "auth.codeTitle": "Iċċekkja l-email tiegħek",
    "auth.codeSent": "Bgħatna kodiċi ta' 6 ċifri lil {email}. Ikteb hawn:",
    "auth.codeLabel": "Kodiċi biex tidħol",
    "auth.codeBtn": "Idħol",
    "auth.junk": "Ma tarahiex? Tista' tieħu minuta. Ħares ukoll fil-folder Spam jew Junk, u mmarkaha \"Mhux spam\" biex l-emails li jmiss jaslu fl-inbox.",
    "auth.otherEmail": "Uża email oħra",
    'auth.dev': 'Mod ta’ żvilupp (bla server tal-email):',
    'auth.devLink': 'ikklikkja hawn biex tidħol',
    'auth.fine': 'Nużaw l-email tiegħek biss biex tidħol. Ara l-{link}.',
    'auth.privacy': 'avviż tal-privatezza',
    'auth.yourAccount': 'Il-kont tiegħek',
    'auth.signedInAs': 'Dħalt bħala {email}',
    'auth.followCount': 'Qed issegwi {n} pajjiżi, sinkronizzati fuq l-apparati kollha tiegħek.',
    'auth.signOut': 'Oħroġ',
    'auth.delete': 'Ħassar il-kont tiegħi',
    "auth.confirmDelete": "Tħassar il-kont tiegħek? Dan iħassar l-email u l-pajjiżi ssejvjati tiegħek, u ma tibqax tirċievi emails minn NewsNetWide. Ma jistax jitreġġa’ lura.",
    'auth.deletedTitle': 'Il-kont tħassar',
    "auth.deletedSub": "L-email, il-pajjiżi ssejvjati u l-abbonament tal-email tiegħek tħassru.",
    'auth.inTitle': 'Dħalt',
    'auth.inSub': 'Merħba, {email}. Il-pajjiżi li ssegwi issa huma ssejvjati fil-kont tiegħek.',
    'auth.expired': 'Dan il-link skada. Itlob wieħed ġdid hawn taħt.',
    'auth.used': 'Dan il-link diġà ntuża jew mhux validu. Itlob wieħed ġdid hawn taħt.',
    'share.source': 'Sors',
    'share.tagline': 'Kull aħbar li tiċċaqlaq is-swieq, fuq globu wieħed',
    'share.notAdvice': 'Aħbarijiet, mhux parir finanzjarju',
    'mc.open': 'Miftuħ',
    'mc.pre': 'Qabel il-ftuħ',
    'mc.post': 'Wara l-għeluq',
    'mc.night': 'Sessjoni ta’ bil-lejl',
    'mc.break': 'Waqfa ta’ nofsinhar',
    'mc.closed': 'Magħluq',
    'mc.holiday': 'Btala',
    'mc.closesIn': 'Jagħlaq fi żmien {t}',
    'mc.opensIn': 'Jiftaħ fi żmien {t}',
    'mc.endsIn': 'Jispiċċa fi żmien {t}',
    'mc.reopensIn': 'Jerġa’ jiftaħ fi żmien {t}',
    'mc.preIn': 'Qabel il-ftuħ fi żmien {t}',
    'mc.afterIn': 'Wara l-għeluq fi żmien {t}',
    'mc.nightIn': 'Sessjoni ta’ bil-lejl fi żmien {t}',
    'mc.openCount': '{n} miftuħa',
    'mc.all': 'Is-swieq kollha',
    "mc.title": "Ħinijiet tas-swieq",
    "side.countries": "Pajjiżi",
    "side.menu": "Menu",
    "tools.pricingSub": "Il-pjanijiet u x’jinkludi kull wieħed",
    'mc.noHolidays': 'mingħajr btajjel',
    'mc.local': 'ħin lokali',
    'mc.note': 'Il-ħinijiet regolari ta’ kull borża skont il-ħin lokali tagħha. Il-btajjel huma inklużi għas-swieq tal-Istati Uniti, ir-Renju Unit, il-Ġermanja u Euronext Paris (2026–27); boroż oħra jistgħu jkunu magħluqa f’btajjel lokali. Is-sessjonijiet ta’ bil-lejl huma sessjonijiet ta’ futures fuq indiċijiet (Tokyo OSE, Hong Kong HKFE).',
    'topic.markets': 'L-aħbarijiet tas-swieq jittrattaw il-prezzijiet tal-ishma, bonds, muniti u komoditajiet: x’qed jixtru u jbigħu l-investituri, u għaliex.',
    'topic.economy': 'L-aħbarijiet ekonomiċi (tkabbir, impjiegi, inflazzjoni, kummerċ) jaffettwaw il-profitti tal-kumpaniji u d-deċiżjonijiet tal-banek ċentrali fix-xhur li ġejjin.',
    'topic.central-banks': 'Il-banek ċentrali jiffissaw ir-rati tal-imgħax, il-prezz tal-flus, li jaffettwa self, tfaddil, muniti u prezzijiet tal-assi.',
    'topic.policy': 'Id-deċiżjonijiet tal-gvernijiet (taxxi, baġits, regoli tal-kummerċ, sanzjonijiet, elezzjonijiet, kunflitti) jistgħu jbiddlu l-ispejjeż u r-riskji ta’ setturi sħaħ.',
    'topic.companies': 'L-aħbarijiet tal-kumpaniji (riżultati, ftehimiet, tnaqqis ta’ impjiegi) jistgħu jiċċaqilqu l-ishma tagħhom u kultant is-settur kollu.',
    "snap.title": "Stampa għall-investituri",
    "snap.source": "L-aħħar ċifri uffiċjali annwali · World Bank Open Data. Kuntest, mhux tbassir jew parir.",
    "snap.gdp_growth": "Tkabbir tal-PDG",
    "snap.inflation": "Inflazzjoni",
    "snap.unemployment": "Qgħad",
    "snap.gdp_per_capita": "PDG għal kull persuna",
    "snap.current_account": "Kont kurrenti",
    "snap.exports": "Esportazzjonijiet",
    "snap.ofGdp": "tal-PDG",
    "snap.gdp.shrink": "L-ekonomija qed tiċkien.",
    "snap.gdp.slow": "Tkabbir bil-mod.",
    "snap.gdp.moderate": "Tkabbir moderat.",
    "snap.gdp.fast": "Tkabbir mgħaġġel.",
    "snap.inf.deflation": "Il-prezzijiet qed jinżlu (deflazzjoni).",
    "snap.inf.target": "Qrib it-2% li ħafna banek ċentrali jimmiraw għalih.",
    "snap.inf.above": "’Il fuq mill-miri tas-soltu tal-banek ċentrali.",
    "snap.inf.high": "Inflazzjoni għolja: il-flus jitilfu l-valur malajr.",
    "snap.unemp.low": "Baxx: is-suq tax-xogħol huwa strett.",
    "snap.unemp.moderate": "Moderat.",
    "snap.unemp.high": "Għoli: ħafna nies ma jsibux xogħol.",
    "snap.gdppc.note": "Il-produzzjoni medja għal kull persuna: kejl approssimattiv ta’ kemm hu sinjur pajjiż.",
    "snap.ca.surplus": "Bilanċ pożittiv: jaqla’ aktar mill-barra milli jonfoq.",
    "snap.ca.deficit": "Defiċit: jonfoq aktar barra milli jaqla’, u jiddependi fuq flus barranin.",
    "snap.exp.very": "Jiddependi ħafna fuq il-kummerċ: sensittiv għat-tariffi u d-domanda globali.",
    "snap.exp.open": "Ekonomija miftuħa għall-kummerċ.",
    "snap.exp.domestic": "Immexxija l-aktar mis-suq intern tagħha.",
    "auth.since": "Membru minn {date}",
    "auth.followed": "Pajjiżi li qed issegwi",
    "auth.noneFollowed": "Għadek m’għandek l-ebda wieħed. Agħfas ☆ Segwi fuq kwalunkwe pajjiż biex iżżidu hawn.",
    "auth.unfollow": "Ieqaf segwi {country}",
    "auth.email": "Email",
    "auth.prefUpdates": "Aġġornamenti ta’ NewsNetWide",
    "auth.prefUpdatesSub": "Funzjonijiet ġodda u aħbarijiet dwar is-sit",
    "auth.prefNews": "Newsletter",
    "auth.prefNewsSub": "L-aqwa aħbarijiet tas-swieq",
    "auth.saved": "Issejvjat.",
    "auth.prefsError": "Is-settings tal-email mhumiex disponibbli bħalissa.",
    "auth.plan": "Pjan",
    "auth.seePlans": "Ara l-pjanijiet",
    "auth.manage": "Immaniġġja l-abbonament",
    "auth.trialUntil": "prova b’xejn sal-{date}",
    "auth.renews": "jiġġedded fil-{date}",
    "auth.endsOn": "jispiċċa fil-{date}",
    "auth.briefing": "Briefing ta' filgħodu",
    "auth.briefingOn": "Ibgħatli briefing kull filgħodu",
    "auth.briefingSub": "L-aqwa aħbarijiet mill-pajjiżi li ssegwi, u d-dati importanti li ġejjin. Tista' twaqqfu meta trid.",
    "auth.briefingNone": "Għadek ma ssegwi l-ebda pajjiż, allura jibda bl-aqwa aħbarijiet tad-dinja.",
    "auth.briefingCount": "Pajjiżi fil-briefing tiegħek: {n}",
    "auth.briefingAt": "Ibgħatu fil-",
    "auth.briefingTz": "il-ħin tiegħek ({tz})",
    "auth.briefingPreview": "Ara l-eżempju tal-lum ↗",
    "panel.page": "Paġna tal-pajjiż ↗",
    "footer.countries": "Pajjiżi",
    glossary: {
        'central-bank': ['Bank ċentrali', 'L-istituzzjoni li tiffissa r-rati tal-imgħax ta’ pajjiż u tmexxi l-provvista tal-flus.', 'Id-deċiżjonijiet tiegħu jbiddlu l-ispiża tas-self għal kulħadd u jiċċaqilqu l-bonds, l-ishma u l-munita.'],
        fed: ['Federal Reserve (Fed)', 'Il-bank ċentrali tal-Istati Uniti; il-kumitat tiegħu (FOMC) jiffissa r-rati tal-imgħax Amerikani.', 'Ir-rati Amerikani jaffettwaw l-ispiża tas-self u l-flussi tal-investiment madwar id-dinja.'],
        ecb: ['Bank Ċentrali Ewropew (BĊE)', 'Il-bank ċentrali tal-20 pajjiż li jużaw l-euro, inkluża Malta.', 'Id-deċiżjonijiet tiegħu jaffettwaw is-self għad-djar, is-self lin-negozji u l-valur tal-euro.'],
        boe: ['Bank tal-Ingilterra', 'Il-bank ċentrali tar-Renju Unit; il-Kumitat tal-Politika Monetarja tiegħu jiffissa r-rati.', 'Id-deċiżjonijiet tiegħu jiċċaqilqu l-lira sterlina, il-bonds tal-gvern Ingliż u l-ispiża tas-self.'],
        boj: ['Bank tal-Ġappun', 'Il-bank ċentrali tal-Ġappun.', 'Bidliet fir-rati baxxi ħafna tal-Ġappun jistgħu jiċċaqilqu l-yen u l-flussi tal-kapital globali.'],
        'interest-rate': ['Rata tal-imgħax', 'Il-prezz tas-self tal-flus, normalment perċentwal fis-sena.', 'Rati ogħla jagħmlu s-self aktar għali u ġeneralment inaqqsu l-infiq; rati aktar baxxi jagħmlu l-oppost.'],
        'rate-cut': ['Tnaqqis fir-rati', 'Bank ċentrali jbaxxi r-rata tal-imgħax tiegħu.', 'Self orħos jista’ jgħin l-infiq u l-profitti, iżda jista’ juri wkoll tħassib dwar l-ekonomija.'],
        'rate-hike': ['Żieda fir-rati', 'Bank ċentrali jgħolli r-rata tal-imgħax tiegħu.', 'Normalment il-għan huwa li titnaqqas l-inflazzjoni; is-self isir aktar għali għall-familji u n-negozji.'],
        'basis-points': ['Punti bażi', 'Punt bażi wieħed huwa 0.01%; 25 punt bażi huma kwart ta’ punt perċentwali.', 'Il-bidliet fir-rati jingħataw f’punti bażi, għalhekk juru kemm hi kbira l-bidla.'],
        qe: ['Easing kwantitattiv (QE)', 'Bank ċentrali jixtri (QE) jew inaqqas (QT) ammonti kbar ta’ bonds biex jinfluwenza r-rati fit-tul.', 'Ibiddel kemm jiċċirkolaw flus fis-swieq finanzjarji.'],
        inflation: ['Inflazzjoni', 'Ir-rata li biha jogħlew il-prezzijiet; ġeneralment titkejjel bl-indiċi tal-prezzijiet tal-konsumatur.', 'Inflazzjoni għolja tista’ żżomm ir-rati għoljin u tnaqqas il-poter tax-xiri tal-flus.'],
        gdp: ['PDG', 'Il-prodott domestiku gross: il-valur totali tal-prodotti u s-servizzi li tipproduċi ekonomija.', 'Huwa l-kejl l-aktar wiesa’ jekk ekonomija hijiex qed tikber jew tiċkien.'],
        recession: ['Riċessjoni', 'Tnaqqis sinifikanti u mifrux fl-attività ekonomika, ħafna drabi żewġ kwarti ta’ PDG nieżel.', 'Ir-riċessjonijiet normalment ifissru profitti aktar baxxi u aktar qgħad.'],
        unemployment: ['Qgħad', 'Is-sehem ta’ nies li jridu jaħdmu iżda m’għandhomx xogħol; iċ-ċifri tal-impjiegi jgħoddu x-xogħlijiet ġodda.', 'Id-dejta tal-impjiegi turi s-saħħa tal-ekonomija u taffettwa l-banek ċentrali.'],
        pmi: ['PMI', 'Indiċi tal-maniġers tax-xiri: stħarriġ ta’ kull xahar dwar l-attività tan-negozji. ’Il fuq minn 50 ifisser tkabbir.', 'Huwa wieħed mill-ewwel sinjali ta’ fejn sejra l-ekonomija.'],
        'trade-deficit': ['Bilanċ kummerċjali', 'Id-differenza bejn dak li pajjiż jesporta u jimporta.', 'Żbilanċi kbar jistgħu jaffettwaw il-munita u jwasslu għal tilwim kummerċjali.'],
        tariff: ['Tariffa', 'Taxxa fuq prodotti importati.', 'It-tariffi jgħollu l-ispejjeż tal-importazzjoni u jistgħu jnaqqsu l-bejgħ u l-profitti tal-esportaturi.'],
        sanctions: ['Sanzjonijiet', 'Restrizzjonijiet li pajjiż jimponi fuq il-kummerċ jew il-finanzi ma’ pajjiż ieħor.', 'Jistgħu jagħlqu swieq, ifixklu l-ktajjen tal-provvista u jiċċaqilqu l-prezzijiet tal-komoditajiet.'],
        budget: ['Baġit u politika fiskali', 'Kif gvern jiġbor it-taxxi, jonfoq u jissellef.', 'Defiċits kbar jew stimulu jistgħu jaffettwaw it-tkabbir, ir-rendiment tal-bonds u l-munita.'],
        'bond-yield': ['Rendiment tal-bonds', 'Il-qligħ ta’ investitur fuq bond; meta l-prezz tal-bond jinżel, ir-rendiment jogħla.', 'Ir-rendiment tal-bonds tal-gvern jiffissa l-ispiża bażika tas-self fl-ekonomija kollha.'],
        index: ['Indiċi tal-ishma', 'Grupp ta’ ishma li jsegwi suq, bħall-S&P 500 (500 kumpanija kbira Amerikana).', 'L-indiċijiet jiġbru f’numru wieħed kif sejjer suq sħiħ.'],
        'sell-off': ['Bejgħ massiv', 'Perjodu meta ħafna investituri jbigħu flimkien u l-prezzijiet jinżlu malajr.', 'Ħafna drabi juri biża’ jew aħbarijiet ħżiena; ma jgħid xejn ċert dwar dak li ġej.'],
        volatility: ['Volatilità', 'Kemm u kemm malajr jitilgħu u jinżlu l-prezzijiet.', 'Volatilità ogħla tfisser aktar inċertezza u ċaqliq akbar fiż-żewġ direzzjonijiet.'],
        currency: ['Rata tal-kambju', 'Il-prezz ta’ munita espress f’munita oħra.', 'Iċ-ċaqliq fil-muniti jbiddel l-ispiża tal-importazzjoni, tal-ivvjaġġar u l-valur tal-investimenti barranin.'],
        oil: ['Prezzijiet taż-żejt', 'Il-prezz tas-suq taż-żejt mhux maħdum; Brent u WTI huma r-referenzi ewlenin. L-OPEC tiġbor pajjiżi produtturi.', 'Iż-żejt jaffettwa l-ispejjeż tal-fjuwil, it-trasport u l-produzzjoni, u għalhekk l-inflazzjoni.'],
        gold: ['Deheb', 'Id-deheb innegozjat bħala komodità.', 'Ħafna investituri jixtruh fi żminijiet inċerti, għalhekk il-prezz tiegħu spiss juri n-nervożiżmu tas-suq.'],
        crypto: ['Kriptomunita', 'Assi diġitali bħall-bitcoin, innegozjati 24/7 mingħajr bank ċentrali.', 'Il-prezzijiet huma volatili ħafna u jirreaġixxu għar-regolamentazzjoni u l-aptit għar-riskju.'],
        etf: ['ETF', 'Fond innegozjat fil-borża bħal sehem, li normalment isegwi indiċi.', 'L-ETFs huma mod komuni u irħis biex tinvesti f’suq sħiħ.'],
        earnings: ['Qligħ', 'Il-profitt irrappurtat ta’ kumpanija għal perjodu, ħafna drabi għal kull sehem (EPS).', 'Riżultati aħjar jew agħar minn dak mistenni mill-analisti spiss jiċċaqilqu l-prezz tal-ishma.'],
        revenue: ['Dħul', 'Il-flus kollha li kumpanija tieħu mill-bejgħ tal-prodotti jew is-servizzi tagħha, qabel l-ispejjeż.', 'It-tkabbir fid-dħul juri jekk id-domanda għall-prodotti tagħha hijiex qed tiżdied.'],
        guidance: ['Previżjoni tal-kumpanija', 'Il-previżjoni tal-kumpanija stess għar-riżultati futuri tagħha.', 'Bidliet fil-previżjoni spiss jgħoddu daqs ir-riżultati tal-passat għall-investituri.'],
        ipo: ['Offerta pubblika inizjali (IPO)', 'Meta kumpanija tbigħ ishma għall-ewwel darba f’borża.', 'Il-pubbliku jkun jista’ jinvesti fiha, u turi l-aptit għal listings ġodda.'],
        merger: ['Għaqdiet u akkwiżizzjonijiet', 'Kumpanija tingħaqad ma’ oħra jew tixtriha.', 'Il-ftehimiet jistgħu jbiddlu l-kompetizzjoni u spiss jiċċaqilqu l-ishma taż-żewġ kumpaniji.'],
        buyback: ['Xiri lura tal-ishma', 'Kumpanija tixtri lura l-ishma tagħha stess mis-suq.', 'Jirritorna flus lill-azzjonisti u jnaqqas in-numru ta’ ishma; mhux garanzija ta’ valur.'],
        dividend: ['Dividend', 'Parti mill-profitt imħallsa lill-azzjonisti.', 'Bidliet fid-dividend juru kemm il-kumpanija hija kunfidenti dwar il-flus tagħha.'],
        layoffs: ['Tkeċċijiet', 'Kumpanija tnaqqas l-għadd tal-impjegati tagħha.', 'Jista’ juri pressjoni fuq l-ispejjeż jew ristrutturar, u jaffettwa s-suq tax-xogħol.'],
        bankruptcy: ['Falliment', 'Proċess legali meta kumpanija ma tistax tħallas id-djun tagħha.', 'L-azzjonisti ġeneralment jitilfu kważi kollox; il-kredituri jistgħu jirkupraw parti.'],
    },
    // Calendar (/calendar)
    "nav.calendar": "Kalendarju",
    "nav.tools": "Għodod",
    "nav.pricing": "Prezzijiet",
    "tools.soon": "DALWAQT",
    "tools.briefing": "Briefing ta' filgħodu",
    "tools.briefingSub": "L-aħbarijiet tal-pajjiżi tiegħek bl-email, kull filgħodu",
    "tools.calculators": "Kalkulaturi finanzjarji",
    "tools.calculatorsSub": "Imgħax kompost, miri ta' tfaddil, miżati",
    "tools.holdings": "Monitoraġġ tal-ishma",
    "tools.holdingsSub": "L-aħbarijiet dwar il-kumpaniji li għandek",
    "tools.papers": "Analiżi ta' riċerka",
    "tools.papersSub": "Kull riċerka, spjegata b'mod sempliċi",
    "tools.montecarlo": "Simulatur Monte Carlo",
    "tools.montecarloSub": "Tfaddil, trading u strateġiji tal-opzjonijiet, b'PDF",
    "cal.title": "Kalendarju ekonomiku",
    "cal.sub": "Deċiżjonijiet tal-banek ċentrali, data ekonomika ewlenija, għeluq tas-swieq u btajjel pubbliċi, minn sorsi uffiċjali, fiż-żona tal-ħin tiegħek.",
    "cal.todayLabel": "Illum",
    "cal.tomorrow": "Għada",
    "cal.yesterday": "Ilbieraħ",
    "cal.allDay": "Il-ġurnata kollha",
    "cal.now": "issa",
    "cal.inDH": "fi {d} jum {h} siegħa",
    "cal.inHM": "fi {h} siegħa {m} min",
    "cal.inM": "fi {m} min",
    "cal.decision": "{bank}: deċiżjoni dwar ir-rati",
    "cal.closed": "{exchange} magħluqa",
    "cal.early": "{exchange} tagħlaq kmieni",
    "cal.estimated": "data stmata",
    "cal.yourTz": "Il-ħinijiet fiż-żona tal-ħin tiegħek ({tz})",
    "cal.type.public_holiday": "Btajjel pubbliċi",
    "cal.allCountries": "Il-pajjiżi kollha",
    "cal.yourCountries": "Il-pajjiżi tiegħek",
    "cal.noFollows": "Segwi pajjiżi fuq il-globu biex tiffiltra bihom hawn.",
    "cal.addToCal": "Żid mal-kalendarju",
    "cal.subscribe": "Abbona",
    "cal.subscribeHint": "Ikkopja din il-link f'Google Calendar, Apple Calendar jew Outlook (\"żid minn URL\"). Jaġġorna waħdu.",
    "cal.copied": "Il-link ġiet ikkopjata",
    "cal.source": "Sors uffiċjali",
    "cal.relatedNews": "Aħbarijiet dwar {country}",
    "cal.period": "Perjodu: {period}",
    "cal.none": "M'hemm xejn skedat għal dawn il-filtri.",
    "cal.error": "Il-kalendarju mhux disponibbli bħalissa. Erġa' pprova ftit wara.",
    "cal.comingUp": "Ġej",
    "cal.fullCalendar": "Il-kalendarju kollu",
    "cal.euroArea": "Żona tal-euro",
    "cal.note": "Id-dati u l-ħinijiet ġejjin minn kull bank ċentrali, borża u uffiċċju tal-istatistika (link fuq kull avveniment). Btajjel pubbliċi: il-librerija open-source \"holidays\" (MIT). Qatt ma nuru tbassir. Aħbarijiet u kuntest, mhux parir finanzjarju.",
    "cal.series.us_cpi": "Prezzijiet tal-konsumatur tal-Istati Uniti (CPI)",
    "cal.series.us_jobs": "Rapport tax-xogħol tal-Istati Uniti",
    "cal.series.us_ppi": "Prezzijiet tal-produtturi tal-Istati Uniti (PPI)",
    "cal.series.us_jolts": "Postijiet battala tal-Istati Uniti (JOLTS)",
    "cal.series.us_eci": "Indiċi tal-ispiża tal-impjiegi tal-Istati Uniti",
    "cal.series.us_gdp": "PDG tal-Istati Uniti",
    "cal.series.us_pce": "Dħul u nfiq personali tal-Istati Uniti (PCE)",
    "cal.series.us_trade": "Bilanċ kummerċjali tal-Istati Uniti",
    "cal.series.ea_hicp_flash": "Inflazzjoni taż-żona tal-euro (stima rapida)",
    "cal.series.ea_hicp": "Inflazzjoni taż-żona tal-euro (finali)",
    "cal.series.ea_gdp_flash": "PDG taż-żona tal-euro (stima rapida preliminari)",
    "cal.series.ea_gdp": "PDG u impjiegi taż-żona tal-euro",
    "cal.series.ea_unemployment": "Qgħad fiż-żona tal-euro",
    "cal.series.ea_retail": "Bejgħ bl-imnut fiż-żona tal-euro",
    "cal.series.uk_cpi": "Prezzijiet tal-konsumatur tar-Renju Unit (CPI)",
    "cal.series.uk_gdp_q": "PDG tar-Renju Unit (kull tliet xhur)",
    "cal.series.uk_gdp_m": "PDG tar-Renju Unit (kull xahar)",
    "cal.series.uk_jobs": "Suq tax-xogħol tar-Renju Unit",
    "cal.series.uk_retail": "Bejgħ bl-imnut tar-Renju Unit",
    "cal.series.au_cpi": "Prezzijiet tal-konsumatur tal-Awstralja (CPI)",
    "cal.series.au_jobs": "Forza tax-xogħol tal-Awstralja",
    "cal.series.au_gdp": "PDG tal-Awstralja",
    "bank.snb": "Bank Nazzjonali Żvizzeru",
    "bank.boc": "Bank tal-Kanada",
    "bank.rba": "Bank tar-Riżerva tal-Awstralja",
    "bank.rbnz": "Bank tar-Riżerva ta' New Zealand",
    "bank.riksbank": "Riksbank (l-Iżvezja)",
    "bank.norges": "Norges Bank (in-Norveġja)",
    "bank.rbi": "Bank tar-Riżerva tal-Indja",
    "cal.promise1": "Sorsi uffiċjali biss",
    "cal.promise2": "L-ebda tbassir, dati u riżultati biss",
    "cal.promise3": "Abbonament b'xejn għall-kalendarju",
    "cal.yourTimeShort": "il-ħin tiegħek",
    "cal.unitD": "jiem",
    "cal.unitH": "siegħa",
    "cal.unitM": "min",
    "cal.approxNote": "Ħin approssimattiv: il-bank ma jiffissahx minn qabel",
    "cal.then": "Imbagħad:",
    "cal.nextDecisions": "Id-deċiżjonijiet li jmiss dwar ir-rati",
    "cal.bankCalendars": "Kalendarji uffiċjali tal-banek · għadd sat-tħabbira",
    "cal.marketsWeek": "Il-boroż din il-ġimgħa",
    "cal.mktAside": "Għeluq din il-ġimgħa: {n} · ħinijiet f'{tz}",
    "cal.mktNote": "Is-sessjoni ewlenija biss. L-għeluq ġej mil-lista uffiċjali tal-btajjel ta' kull borża.",
    "cal.exchange": "Borża",
    "cal.rightNow": "Bħalissa",
    "cal.mkt.open": "Miftuħa",
    "cal.mkt.pre": "Għadha ma fetħitx",
    "cal.mkt.break": "Waqfa tan-nofsinhar",
    "cal.mkt.closedToday": "Magħluqa llum",
    "cal.mkt.closed": "Magħluqa",
    "cal.mkt.closesAt": "tagħlaq fil-{time} (il-ħin tiegħek)",
    "cal.mkt.opensAt": "tiftaħ fil-{time} (il-ħin tiegħek)",
    "cal.mkt.earlyAt": "Tagħlaq kmieni fil-{time}",
    "cal.local": "ħin lokali",
    "cal.country": "Pajjiż",
    "cal.types": "Tipi ta' avvenimenti",
    "cal.group.central_bank": "Banek ċentrali",
    "cal.group.data_release": "Data ekonomika",
    "cal.group.markets": "Għeluq tas-swieq",
    "cal.group.public_holiday": "Btajjel pubbliċi",
    "cal.badge.central_bank": "Deċiżjoni dwar ir-rati",
    "cal.badge.data_release": "Pubblikazzjoni ta' data",
    "cal.badge.market_closed": "Suq magħluq",
    "cal.badge.early_close": "Għeluq kmieni",
    "cal.badge.public_holiday": "Btala pubblika",
    "cal.closesEarly": "għeluq kmieni",
    "cal.noTrading": "l-ebda negozjar il-ġurnata kollha",
    "cal.released": "Ippubblikat",
    "cal.seeFigure": "Ara ċ-ċifra uffiċjali",
    "cal.sourceShort": "Sors",
    "cal.news": "Aħbarijiet",
    "cal.openNote": "{exchange} miftuħa",
    "cal.plusMore": "+{n} oħra",
    "cal.oneEvent": "Avveniment wieħed",
    "cal.nEvents": "Avvenimenti: {n}",
    "cal.oneHoliday": "Btala waħda",
    "cal.nHolidays": "Btajjel: {n}",
    "cal.nowLine": "Issa · {time}",
    "cal.weekendClosed": "Tmiem il-ġimgħa: il-boroż magħluqa.",
    "cal.nothingDay": "Xejn skedat.",
    "cal.thisWeek": "Din il-ġimgħa",
    "cal.nextWeekLabel": "Il-ġimgħa d-dieħla",
    "cal.earlier": "Aktar kmieni din il-ġimgħa",
    "cal.show": "Uri",
    "cal.tryAll": "Agħżel it-tipi kollha ta' avvenimenti jew itfi \"Il-pajjiżi tiegħek\".",
    "cal.reset": "Neħħi l-filtri",
    "cal.prevWeek": "Il-ġimgħa ta' qabel",
    "cal.nextWeek": "Il-ġimgħa ta' wara",
    "cal.moreWeek": "Uri l-ġimgħa ta' wara",
    "cal.subscribeTitle": "Abbona għal dan il-kalendarju",
    "cal.feedAddress": "Indirizz tal-kalendarju",
    "cal.copyLink": "Ikkopja l-link",
    "cal.subFine": "B'xejn, mingħajr kont. Isegwi l-filtri li għażilt. Aħbarijiet u kuntest, mhux parir finanzjarju.",
    "cal.impact": "Impatt",
    "cal.imp.high": "Għoli",
    "cal.imp.medium": "Medju",
    "cal.imp.low": "Baxx",
    "cal.impTip.high": "normalment iċaqlaq ir-rati, il-muniti u l-ishma",
    "cal.impTip.medium": "is-swieq isegwuh, iċaqlaqhom inqas spiss",
    "cal.impTip.low": "sfond: btajjel, data inqas importanti",
    "cal.impNote": "Skont it-tip ta' avveniment, mhux tbassir.",
    "cal.impAll": "Kollha",
    "cal.impMediumUp": "Medju +",
    "cal.impHighOnly": "Għoli biss",
    "cal.nHigh": "Impatt għoli: {n}",
    "cal.addShort": "Żid",
};
